module.exports = __webpack_public_path__ + "images/banners/sns_campaign/tweet_campaign202008_banner_pc_eae93e4516785abb2b1dfb31e5d48df4.jpg";